<template>
  <BaseButton
    :size="size"
    :data-testid="dataTestId"
    class="tw:font-bold tw:border tw:bg-black tw:border-black tw:text-white tw:text-wrap"
    v-bind="$attrs"
  >
    <slot />
  </BaseButton>
</template>

<script setup>
import BaseButton from './BaseButton.vue'

defineProps({
  size: {
    type: String,
    default: 'big',
  },
  dataTestId: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
@media (hover: hover) and (pointer: fine) {
  button:hover {
    background-color: var(--tw-color-gray-700);
    border-color: var(--tw-color-gray-700);
  }
}
button:disabled {
  background-color: var(--tw-color-gray-300);
  border-color: var(--tw-color-gray-300);
}
</style>
